export default __webpack_public_path__ + "static/media/likeButtonPic.64c18a41.png";